import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CustomSvg from './BaseIcon';
const RateArrowIcon = ({ height = 16, width = 16, }) => {
    return (_jsxs(CustomSvg, { width: width, height: height, viewBox: "0 0 16 16", fill: "none", children: [_jsx("path", { d: "M4 8L12 8", stroke: "#B9BABC", strokeLinecap: "round", strokeLinejoin: "round" }), _jsx("path", { d: "M10 6L12 8L10 10", stroke: "#B9BABC", strokeLinecap: "round", strokeLinejoin: "round" })] }));
};
export default RateArrowIcon;
//# sourceMappingURL=RateArrowIcon.js.map